import Cookie from 'js-cookie';
import { useEffect, useState } from 'react';

const COOKIE_NAME = 'nextgenui';

export const useNextGenUiCookie = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const cookie = Cookie.get(COOKIE_NAME);
    // if cookie exists, but has no value js-cookie returns 'undefined'.
    if (cookie || cookie === 'undefined') {
      setEnabled(true);
    }
  }, []);

  return {
    enabled,
    enableNextGenUi: () => {
      Cookie.set(COOKIE_NAME, 'true');
      setEnabled(true);
      window.location.reload();
    },
    disableNextGenUi: () => {
      Cookie.remove(COOKIE_NAME);
      setEnabled(false);
      window.location.reload();
    },
  };
};
